import React from "react";
import moment from "jalali-moment";

const convertSecondsToMinutesAndSeconds = (props) => {
  const minutes = Math.floor(props / 60);
  const remainingSeconds = props % 60;
  return (
    (minutes != 0 ? `${minutes} دقیقه و ` : "") +
    (remainingSeconds !== 0 ? `${remainingSeconds} ثانیه` : "")
  );
};

export default convertSecondsToMinutesAndSeconds;
